<template>
    <common-modal v-if="isOpen" width="medium" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <common-page-header
                :heading="$t('modals.change_practice_email.heading')"
                :content="emailLabelHeading"
                :isCenter="true"
                contentSpacing="medium"
                contentColor="secondary"
            ></common-page-header>
            <common-content-wrapper width="small">
                <edit-practice @cancel="emitEvent({ name: 'close' })" @success="success"></edit-practice>
            </common-content-wrapper>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import EditPractice from 'components/forms/practice/EditPractice'

    export default {
        components: { EditPractice },

        props: {
            isOpen: { type: Boolean, required: true },
        },
        computed: {
            emailLabelHeading() {
                return this.$auth.isPracticeAncillary
                    ? this.$t('modals.change_ancillary_email.content')
                    : this.$t('modals.change_practice_email.content')
            },
        },
        methods: {
            success(ev) {
                this.emitEvent({ name: 'email-changed', payload: ev })
            },
        },
    }
</script>
